/* Quick view behaviour. Markup and styles live in snippets/quick-view.liquid.

   The gallery copies the product cards on the home page exactly: hovering the photo
   starts it swiping every 1100ms, leaving it stops and returns to the first frame.
   assets/global.js does the same thing for [data-swipe] cards. The one addition is a
   cloned first frame at the end of the track, so the wrap keeps moving left instead of
   snapping backwards on a picture this size.

   On touch screens there is no hover, so the photos are dragged like the cards. */
(function () {
  var root = document.querySelector('[data-qv]');
  if (!root) return;

  var panel   = root.querySelector('.qv__panel');
  var media   = root.querySelector('.qv__media');
  var stage   = root.querySelector('[data-qv-stage]');
  var dots    = root.querySelector('[data-qv-dots]');
  var prevBtn = root.querySelector('[data-qv-prev]');
  var nextBtn = root.querySelector('[data-qv-next]');
  var elKind  = root.querySelector('[data-qv-kind]');
  var elTitle = root.querySelector('[data-qv-title]');
  var elPrice = root.querySelector('[data-qv-price]');
  var elBlurb = root.querySelector('[data-qv-blurb]');
  var optWrap = root.querySelector('[data-qv-opt]');
  var optName = root.querySelector('[data-qv-optname]');
  var swWrap  = root.querySelector('[data-qv-swatches]');
  var shownEl = root.querySelector('[data-qv-shown]');
  var addBtn  = root.querySelector('[data-qv-add]');
  var soldEl  = root.querySelector('[data-qv-sold]');
  var delEl   = root.querySelector('[data-qv-delivery]');
  var fullEl  = root.querySelector('[data-qv-full]');

  var SWIPE_MS = 1100;   /* same cadence as the cards in assets/global.js */
  var SLIDE_MS = 560;

  var opener = null;
  var count = 0;
  var idx = 0;
  var scrollY = 0;
  var cycle = null;

  function reduced() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function payloadFor(el) {
    var card = el.closest('.card');
    if (!card) return null;
    var tag = card.querySelector('[data-qv-data]');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function jump(k) {
    stage.classList.add('qv-nojump');
    idx = k;
    stage.style.transform = 'translateX(-' + (k * 100) + '%)';
    void stage.offsetHeight;
    stage.classList.remove('qv-nojump');
  }

  function paintDots() {
    var live = count ? (idx % count) : 0;
    for (var n = 0; n < dots.children.length; n++) {
      dots.children[n].classList.toggle('on', n === live);
    }
  }

  function slideTo(k) {
    idx = k;
    stage.style.transform = 'translateX(-' + (k * 100) + '%)';
    paintDots();
    if (k === count) {
      // sitting on the clone, which looks identical to the first frame.
      // snap back with the transition off so the motion never runs backwards.
      setTimeout(function () { if (idx === count) { jump(0); paintDots(); } }, SLIDE_MS);
    }
  }

  function next() { if (count > 1 && idx + 1 <= count) { slideTo(idx + 1); } }
  function prev() {
    if (count < 2) return;
    if (idx === 0) { jump(count); }
    slideTo(idx - 1);
  }

  function startCycle() {
    stopCycleTimer();
    if (count < 2 || reduced()) return;
    cycle = setInterval(next, SWIPE_MS);
  }

  function stopCycleTimer() {
    if (cycle) { clearInterval(cycle); cycle = null; }
  }

  function stopCycle() {
    stopCycleTimer();
    if (count < 2) return;
    if (idx === count) { jump(0); } else if (idx !== 0) { slideTo(0); }
    paintDots();
  }

  function paintGallery(d) {
    stopCycleTimer();
    stage.textContent = '';
    dots.textContent = '';
    jump(0);

    var list = d.images || [];
    count = list.length;

    for (var n = 0; n < count; n++) {
      var im = document.createElement('img');
      im.src = list[n];
      im.alt = (d.alts && d.alts[n]) ? d.alts[n] : d.title;
      im.loading = n === 0 ? 'eager' : 'lazy';
      stage.appendChild(im);

      var dot = document.createElement('span');
      if (n === 0) dot.className = 'on';
      dots.appendChild(dot);
    }

    if (count > 1) {
      var clone = document.createElement('img');
      clone.src = list[0];
      clone.alt = '';
      clone.setAttribute('aria-hidden', 'true');
      clone.loading = 'lazy';
      stage.appendChild(clone);
    }

    var many = count > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
    dots.style.display = many ? '' : 'none';
  }

  function setVariant(v, d) {
    addBtn.setAttribute('data-quick-add', v.id);
    addBtn.setAttribute('data-title', d.title + ' in ' + v.label);
    optName.textContent = v.label;
    elPrice.innerHTML = (d.compare ? '<s>' + d.compare + '</s>' : '') + v.price;

    if (d.shown && v.label !== d.shown) {
      shownEl.textContent = 'Photographed in ' + d.shown + '. Yours is made in ' + v.label + '.';
      shownEl.hidden = false;
    } else {
      shownEl.hidden = true;
    }

    if (v.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to bag';
      soldEl.hidden = true;
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold out';
      soldEl.hidden = false;
    }
  }

  function paintSwatches(d) {
    swWrap.textContent = '';
    var vars = d.variants || [];
    if (!d.hasColor || vars.length < 2) { optWrap.hidden = true; return; }
    optWrap.hidden = false;

    vars.forEach(function (v, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'swatch' + (v.available ? '' : ' swatch--out');
      b.setAttribute('aria-pressed', n === 0 ? 'true' : 'false');
      b.setAttribute('aria-label', v.label + (v.available ? '' : ', sold out'));
      var s = document.createElement('span');
      s.style.background = v.hex;
      b.appendChild(s);
      b.addEventListener('click', function () {
        for (var m = 0; m < swWrap.children.length; m++) {
          swWrap.children[m].setAttribute('aria-pressed', 'false');
        }
        b.setAttribute('aria-pressed', 'true');
        setVariant(v, d);
      });
      swWrap.appendChild(b);
    });
  }

  function lock() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open(d, trigger) {
    opener = trigger || null;

    elKind.textContent = d.kind || '';
    elTitle.textContent = d.title;
    elBlurb.textContent = d.blurb || '';
    delEl.innerHTML = d.delivery || '';
    fullEl.href = d.url;

    paintGallery(d);
    paintSwatches(d);

    var first = (d.variants && d.variants.length) ? d.variants[0] : null;
    if (first) {
      setVariant(first, d);
    } else {
      shownEl.hidden = true;
      addBtn.setAttribute('data-quick-add', d.variantId || '');
      addBtn.setAttribute('data-title', d.title);
      addBtn.disabled = !d.available;
      addBtn.textContent = d.available ? 'Add to bag' : 'Sold out';
      soldEl.hidden = !!d.available;
      elPrice.innerHTML = (d.compare ? '<s>' + d.compare + '</s>' : '') + d.price;
    }

    lock();
    root.hidden = false;
    // force the layout before adding the class, so the transition has a start state.
    // requestAnimationFrame is throttled in a background tab and left the panel blank.
    void root.offsetHeight;
    root.classList.add('is-in');
    panel.focus();
  }

  function close() {
    if (root.hidden) return;
    stopCycleTimer();
    root.classList.remove('is-in');
    setTimeout(function () {
      root.hidden = true;
      stage.textContent = '';
      count = 0;
      jump(0);
      unlock();
      if (opener && document.contains(opener)) { opener.focus(); }
      opener = null;
    }, 240);
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-qv-open]');
    if (trigger) {
      var d = payloadFor(trigger);
      if (!d) return;
      e.preventDefault();
      open(d, trigger);
      return;
    }
    if (e.target.closest('[data-qv-close]')) { close(); }
  });

  prevBtn.addEventListener('click', function () { stopCycleTimer(); prev(); });
  nextBtn.addEventListener('click', function () { stopCycleTimer(); next(); });

  media.addEventListener('mouseenter', startCycle);
  media.addEventListener('mouseleave', stopCycle);
  media.addEventListener('focusin', startCycle);
  media.addEventListener('focusout', stopCycle);

  var sx = null;
  media.addEventListener('touchstart', function (e) { stopCycleTimer(); sx = e.touches[0].clientX; }, { passive: true });
  media.addEventListener('touchmove', function (e) {
    if (sx === null || count < 2) return;
    var dx = e.touches[0].clientX - sx;
    if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } sx = e.touches[0].clientX; }
  }, { passive: true });
  media.addEventListener('touchend', function () { sx = null; }, { passive: true });

  document.addEventListener('visibilitychange', function () { if (document.hidden) { stopCycleTimer(); } });

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'ArrowLeft') { stopCycleTimer(); prev(); return; }
    if (e.key === 'ArrowRight') { stopCycleTimer(); next(); return; }
    if (e.key !== 'Tab') return;

    var f = panel.querySelectorAll('button:not([disabled]):not([hidden]), a[href], [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var n = 0; n < f.length; n++) { if (f[n].offsetParent !== null) list.push(f[n]); }
    if (!list.length) return;
    var firstEl = list[0];
    var lastEl = list[list.length - 1];
    if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
  });

  // assets/global.js flips the label to "Added" only when the add actually succeeded.
  // Close on that, so a failed add leaves the modal open with the toast visible.
  document.addEventListener('click', function (e) {
    if (root.hidden) return;
    if (!e.target.closest('[data-qv-add]')) return;
    setTimeout(function () {
      if (!root.hidden && addBtn.textContent.trim() === 'Added') { close(); }
    }, 1200);
  });
})();
